import { useParams } from 'react-router';
import { useClient } from '../api';

export const useIsTalkingPointPinned = (talkingPointId?: number): boolean => {
    const { data: client } = useClient();
    const { topicId } = useParams();

    return !!client?.talkingPointPins.some((pin) => pin.topicId === Number(topicId) && pin.talkingPointId === talkingPointId);
};
